import _ from "lodash";
import React from "react";

// DS
import { Dialog } from "@toddle-edu/ds-web";

// Components
import Loading from "UIComponents/Loading";
import I18nHOC from "UIComponents/I18nHOC";

// Modules
import { getAssessmentBasicDetailsQuery } from "Assessments/modules/AssessmentQuery";
import { getAssessmentBasicDetailsFromCache } from "Assessments/modules/AssessmentGraphqlHelpers";
import { getCurrentCurriculumProgramType } from "modules/CommonSelectors";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";

// Utils
import { removeAssessmentFromLocalStorage } from "Assessments/modules/Utils";
import { isGlobalHeaderOnMultipleScreensEnabled } from "Utils";

// third party libs.
import { graphql, compose } from "lib/apolloClient";
import { connect } from "react-redux";

const AssessmentDraftModal = props => {
  const {
    t,
    title,
    onClose,
    courseId,
    isLoading,
    onRetrieveAssignment,
    onCreateNewAssignment,
    creationMode = "ASSESSMENT",
    getCurrentAssessmentTypes,
    assessmentType,
    isGlobalHeaderEnabled,
    testId = "appComponents",
  } = props;

  const currentAssessmentTypes = getCurrentAssessmentTypes();
  const { label, localeLabel } =
    _.get(currentAssessmentTypes, assessmentType) || {};
  const assessmentTypeLabel = localeLabel ? t(localeLabel) : label;

  const _onCreateNewAssignment = () => {
    onCreateNewAssignment?.();

    removeAssessmentFromLocalStorage({
      courseId,
      creationMode,
    });

    onClose?.();
  };

  const _onRetrieveAssignment = () => {
    onRetrieveAssignment?.();
    onClose?.();
  };

  const renderBody = () => {
    if (isLoading) return <Loading />;

    return t("classRoom:you_have_unsaved_work_msg", {
      title: title || t("common:untitled"),
      assessmentType: assessmentTypeLabel,
    });
  };

  const handleClose = () => {
    onClose?.(true);
  };

  return (
    <Dialog
      variant="confirm-dialog"
      title={t("classRoom:you_have_unsaved_work")}
      message={renderBody()}
      buttonOneText={t("common:no_discard_and_start_over")}
      buttonTwoText={t("common:yes_continue")}
      onButtonOneClick={_onCreateNewAssignment}
      onButtonTwoClick={_onRetrieveAssignment}
      onClose={handleClose}
      isButtonOneDisabled={isLoading}
      isButtonTwoDisabled={isLoading}
      dsVersion={"2.0"}
    />
  );
};

const mapStateToProps = state => {
  const isGlobalHeaderEnabled = isGlobalHeaderOnMultipleScreensEnabled();

  return {
    curriculumType: getCurrentCurriculumProgramType(state),
    isGlobalHeaderEnabled,
  };
};

const mapActionCreators = {
  getCurrentAssessmentTypes,
};

export default compose(
  I18nHOC({ resource: ["classRoom"] }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getAssessmentBasicDetailsQuery, {
    name: "getAssessmentBasicDetails",
    skip: ({ assessmentId }) => _.isEmpty(assessmentId),
    options: ({ assessmentId }) => ({
      fetchPolicy: "cache-and-network",
      variables: { id: assessmentId },
    }),
    props({ getAssessmentBasicDetails, ownProps: { isData, isLoading } }) {
      const queryData = getAssessmentBasicDetailsFromCache(
        getAssessmentBasicDetails.variables
      );

      const title = _.get(queryData, "title.value", "");

      const fields = _.get(queryData, "fields", []);

      const assessmentTypeField = _.find(fields, { uid: "assessmentType" });
      const assessmentType = _.get(assessmentTypeField, "value");

      const networkStatus = _.get(getAssessmentBasicDetails, "networkStatus");

      return {
        title,
        assessmentType,
        isData: !_.isEmpty(queryData) && isData,
        isLoading: _.includes([1, 2], networkStatus) || isLoading,
      };
    },
  })
)(AssessmentDraftModal);
